import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { DoughnutChartItem } from '../../shared/components/doughnut-chart/dought-item';
import { Investor } from '../../shared/models/investor';
import { groupBy } from 'underscore';

@Component({
  selector: 'app-asset-allocation',
  templateUrl: './asset-allocation.component.html',
  styleUrls: ['./asset-allocation.component.css']
})
export class AssetAllocationComponent implements OnInit, OnChanges {

  @Input()
  investor: Investor;
  @Input() flags: any;

  totalAssets = 0;

  assetLabels = {
    name: 'Assets',
    percent: 'Allocation',
    return: 'Growth Rate',
    totals: 'Amount',
  }
  currentAssetAllocationItems: Array<DoughnutChartItem>;
  suggestedAssetAllocationItems: Array<DoughnutChartItem>;
  constructor() {
    this.currentAssetAllocationItems = new Array();
    this.suggestedAssetAllocationItems = new Array();
  }

  ngOnInit() {
    this.initChartItems();
  }
  ngOnChanges() {
    this.initChartItems();
  }

  initChartItems() {
    const assetAllocationGroups = groupBy(this.investor.assets, 'asset_allocation_type');
    this.currentAssetAllocationItems = availableGroupings.map(group => {
      const assets = assetAllocationGroups[group.group] || [];
      const assetsTotal = assets.map(a => parseInt(a.value) || 0).reduce((val1, val2) => val1 + val2, 0) || 0;
      const assetsReturns = assets.map(a => parseInt(a.return_percentage + "")).reduce((val1, val2) => val1 + val2, 0) || 0;
      let percent = 0;
      console.log(assetsReturns, assets);
      if (assetsReturns > 0 && assetsTotal > 0) {
        percent = Math.floor((assetsReturns / assets.length) * 100) / 100
      }
      return new DoughnutChartItem(group.name, assetsTotal, group.color, percent);
    });
    this.totalAssets = this.currentAssetAllocationItems.reduce((acc, item) => {
      return acc + item.count;
    }, 0);
    this.suggestedAssetAllocationItems = availableGroupings.map(group => {
      return new DoughnutChartItem(group.name, group.suggested_value, group.color, 6);
    });
  }

}

// export const availableGroupings = [
//   {
//     "group": "cash",
//     "name": "Cash",
//     "color": "#348EA9",
//     "suggested_value": 6
//   },
//   {
//     "group": "debt",
//     "name": "Debt",
//     "color": "#F38C38",
//     "suggested_value": 8
//   },
//   {
//     "group": "equity",
//     "name": "Equity",
//     "color": "#F04946",
//     "suggested_value": 15
//   },
//   {
//     "group": "comodities",
//     "name": "Comodities",
//     "color": "#048EA9",
//     "suggested_value": 9
//   },
//   {
//     "group": "precious_metals",
//     "name": "Precious Metals",
//     "color": "#53BB9B",
//     "suggested_value": 8
//   },
//   {
//     "group": "real_estate",
//     "name": "Real Estate",
//     "color": "#8562A3",
//     "suggested_value": 8
//   },
//   {
//     "group": "other_assets",
//     "name": "Other Assets",
//     "color": "#D48EA9",
//     "suggested_value": 6
//   }
// ];

export const availableGroupings = [
  {
    "group": "cash",
    "name": "Cash",
    "color": "#348EA9",
    "suggested_value": 6,
    "returns": 5
  },
  {
    "group": "comodities",
    "name": "Comodities",
    "color": "#0E4FA8",
    "suggested_value": 9,
    "returns": 10
  },
  {
    "group": "debt",
    "name": "Debt",
    "color": "#F38C38",
    "suggested_value": 8,
    "returns": 7
  },
  {
    "group": "equity",
    "name": "Equity",
    "color": "#F04946",
    "suggested_value": 15,
    "returns": 14
  },
  {
    "group": "other_assets",
    "name": "Other Assets",
    "color": "#D48EA9",
    "suggested_value": 6,
    "returns": 11
  },
  {
    "group": "precious_metals",
    "name": "Precious Metals",
    "color": "#53BB9B",
    "suggested_value": 8,
    "returns": 10
  },
  {
    "group": "real_estate",
    "name": "Real Estate",
    "color": "#8562A3",
    "suggested_value": 8,
    "returns": 8
  }
];



// WEBPACK FOOTER //
// ./src/app/modules/hwcheckup/asset-allocation/asset-allocation.component.ts